import { TASKS } from '../constants/namespaces';
import enviro from 'enviro';
import { createTracker } from 'usage-tracker';
import once from '../utils/once';
const trackerArgs = {
  properties: {
    namespace: TASKS
  },
  onError(err) {
    console.error(err);
  },
  lastKnownEventProperties: ['screen', 'subscreen'],
  debug: () => enviro.debug('customer-data-tracker'),
  standalone: true
};
export const getTracker = once(() => createTracker(trackerArgs));
export const getTrackerSendImmediate = once(() => createTracker(Object.assign({
  bypassPool: true
}, trackerArgs)));